<div class="popup-wrap ma-kh">
    <div class="popup-box" style="width: 54vw; height: 32vw;">
        <form id="inputCode"
            style="width: 80%; margin: 1vw auto 0 auto; display: flex; flex-direction: column; align-items: center;">
            <h2 class="active-done-clik" style="margin-top: 1.5vw; margin-bottom: 1.2vw; font-size: 2.2vw;">{{
                'core.active.title' | translate }}</h2>
            <div class="form-contr" style="width: 100%; display: flex; justify-content: center;">
                <ion-input style="text-transform: uppercase;" class="input-common"
                    [(ngModel)]="inputCode" type="text" name="code"></ion-input>
            </div>
            <div class="btn-popup active-done-clik" style="margin-top: 1.5vw; display: flex; justify-content: center;">
                <button style="margin-right: 0; color: #2CA24C;" (click)="unlockGame()"> {{ 'core.active.send' |
                    translate }}</button>
            </div>
        </form>
        <a class="close-btn popup-close" (click)="onClickClose()"><img src="../../../assets/images/close.png"
                alt=""></a>

        <div class="nhap-makh"
            style="position: absolute; width: 80%; left: 10%; bottom: 2.5vw; display: flex; justify-content: space-between; color: #fff;">
            <a style="text-decoration: underline; font-size: 1.5vw; cursor: pointer;" (click)="onClickBuyCode()"> {{
                'core.active.buy' | translate }}</a>
            <a style="text-decoration: underline; font-size: 1.5vw; cursor: pointer;" (click)="onClickForgotCard()"> {{
                'core.active.forgotCard' | translate }}</a>
        </div>
    </div>
</div>
<div class="popup-wrap forgot-ma-kh">
    <div class="popup-box" style="width: 54vw; height: 32vw;">
        <form id="forgotCard"
            style="width: 80%; margin: 1vw auto 0 auto; display: flex; flex-direction: column; align-items: center;">
            <h2 class="active-done-clik" style="margin-top: 1.5vw; margin-bottom: 1.2vw; font-size: 2.2vw;">{{
                'core.active.forgotCard' | translate | uppercase }}</h2>
            <div class="form-contr" style="width: 100%; display: flex; justify-content: center;">
                <ion-input [(ngModel)]="order.customerPhone" type="text" class="input-common"
                    placeholder="{{'core.active.phone' | translate  }}" name="phone"></ion-input>
            </div>
            <div class="btn-popup active-done-clik" style="margin-top: 1.5vw; display: flex; justify-content: center;">
                <button style="margin-right: 0; color: #2CA24C;" (click)="forgotCard()"> {{ 'core.active.send' |
                    translate }}</button>
            </div>
        </form>
        <a class="close-btn popup-close" (click)="onClickClose()" style="text-decoration: underline;">
            <img src="../../../assets/images/close.png" alt=""></a>
    </div>
</div>
<div class="popup-wrap buy-code">
    <div class="popup-box" style="width: 54vw; height: 36vw;">
        <form id="buy-code"
            style="width: 80%; margin: 0.8vw auto 0 auto; display: flex; flex-direction: column; align-items: center;">
            <h2 class="active-done-clik" style="margin-top: 0.8vw; margin-bottom: 0.6vw; font-size: 2vw;">{{
                'core.active.buy' | translate | uppercase }}</h2>
            <div class="form-contr" style="width: 100%; display: flex; flex-direction: column; align-items: center;">
                <ion-input style="margin-top: 0.2vw; text-transform: uppercase;" clearOnEdit
                    class="input-common" [(ngModel)]="order.voucher" type="text"
                    placeholder="{{'core.active.voucher' | translate  }}" name="voucher"></ion-input>
                <ion-input style="margin-top: 0.2vw;" clearOnEdit class="input-common"
                    [(ngModel)]="order.customerName" type="text" placeholder="{{'core.active.name' | translate  }}"
                    name="name"></ion-input>
                <ion-input style="margin-top: 0.2vw;" class="input-common"
                    [(ngModel)]="order.customerPhone" type="text" placeholder="{{'core.active.phone' | translate  }}"
                    name="phone"></ion-input>
                <ion-input style="margin-top: 0.2vw;" class="input-common"
                    [(ngModel)]="order.customerAddress" type="text"
                    placeholder="{{'core.active.address' | translate  }}" name="address"></ion-input>
            </div>
            <div class="btn-popup active-done-clik" style="margin-top: 0.8vw; display: flex; justify-content: center;">
                <button style="margin-right: 0; color: #2CA24C;" (click)="createOrder(order.voucher)"> {{
                    'core.active.send' | translate }}</button>
            </div>
        </form>
        <a class="close-btn popup-close" (click)="onClickClose()" style="text-decoration: underline;">
            <img src="../../../assets/images/close.png" alt=""></a>
    </div>
</div>
<!--  kick hoat thanh công -->
<div class="popup-wrap active-done">
    <div class="popup-box"
        style="width: 54vw; height: 32vw; display: flex; flex-direction: column; justify-content: center; align-items: center;">
        <form id="activeOk" style="width: 80%; display: flex; flex-direction: column; align-items: center;">
            <h2 style="font-size: 2.2vw; margin-bottom: 1.5vw;">{{ 'core.active.cardSuccess' | translate | uppercase }}
            </h2>
            <div class="btn-popup" style="margin-top: 15px;">
                <button style="margin-right: 0; color: #2CA24C;">{{ 'core.active.playGame' | translate }}</button>
            </div>
        </form>
        <a class="close-btn popup-close" (click)="onClickClose()"><img src="../../../assets/images/close.png"
                alt=""></a>
    </div>
</div>